export class DayViewUserModeEntryWorkViewModel {
    constructor() {
        this.employeeId = "";
        this.employeeName = "";
        this.profileImageUrl = "";
        this.dayEntries = [];
    }
}
export default class DayViewUserModeEntryWorkView extends DayViewUserModeEntryWorkViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
